var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{attrs:{"size":40,"width":3,"color":"primary","indeterminate":_vm.value == null,"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }